export const GET_CONFIRMACAO = '[CONFIRMACAO APP] GET CONFIRMACAO';
export const ADD_CONFIRMACAO = '[CONFIRMACAO APP] ADD CONFIRMACAO';
export const ERROR_CONFIRMACAO = '[CONFIRMACAO APP] CONFIRMACAO ERROR';
export const OPEN_CONFIRMACAO_DIALOG = '[CONFIRMACAO APP] OPEN NEW CONFIRMACAO DIALOG';
export const CLOSE_CONFIRMACAO_DIALOG = '[CONFIRMACAO APP] CLOSE NEW CONFIRMACAO DIALOG';

export function openDialog(id)
{
    return {
        type : OPEN_CONFIRMACAO_DIALOG,
        id : id,
    }
}

export function closeDialog()
{
    return {
        type: CLOSE_CONFIRMACAO_DIALOG
    }
}

export function Error()
{
    return {
        type: ERROR_CONFIRMACAO
    }
}

